// apps/web/src/components/monitoring/MonitoringDashboard.tsx
// System + application + business metrics viewer.

import { useEffect, useState } from 'react';
import { apiClient } from '../../lib/apiClient';

interface MetricBundle {
  system: Record<string, number | string>;
  application: Record<string, number | string>;
  business: Record<string, number | string>;
}

const EMPTY: MetricBundle = { system: {}, application: {}, business: {} };

export function MonitoringDashboard() {
  const [metrics, setMetrics] = useState<MetricBundle>(EMPTY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [s, a, b] = await Promise.all([
          apiClient.get('/metrics/system'),
          apiClient.get('/metrics/application'),
          apiClient.get('/metrics/business'),
        ]);
        setMetrics({
          system: (s.data as { metric: Record<string, number | string> }).metric,
          application: (a.data as { metric: Record<string, number | string> }).metric,
          business: (b.data as { metric: Record<string, number | string> }).metric,
        });
      } catch (err) {
        console.error('monitoring load failed', err);
      } finally {
        setLoading(false);
      }
    };
    void load();
  }, []);

  if (loading) return <div className="loading">Loading metrics…</div>;

  const renderGroup = (name: string, values: Record<string, number | string>) => (
    <div className="metric-group">
      <h3>{name}</h3>
      <div className="metric-cards">
        {Object.entries(values).map(([k, v]) => (
          <div className="metric-card" key={k}>
            <strong>{v}</strong>
            <span>{k}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="monitoring-dashboard">
      <div className="header"><h2>Monitoring</h2></div>
      {renderGroup('System', metrics.system)}
      {renderGroup('Application', metrics.application)}
      {renderGroup('Business', metrics.business)}
    </div>
  );
}